import { render, staticRenderFns } from "./UserAuth.vue?vue&type=template&id=c38d8b22&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"
import style0 from "./UserAuth.vue?vue&type=style&index=0&id=c38d8b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38d8b22",
  null
  
)

export default component.exports